import f, { ODataFilterBuilder } from 'odata-filter-builder';
import * as ODataUtils from '../../../../utils/odata';

export interface ERPGatewayFilterParams {
    companyId?: number;
    lastHealthCheckDate?: Date;
    onlyIncludeHealthChecks?: boolean;
}

export const createERPGatewayFilter = (params: ERPGatewayFilterParams = {}) => {
    const filterRules: ODataFilterBuilder[] = [];

    // TODO: could this work as plain parameter? (observed inconsistent behavior with onlyIncludeHealthChecks)
    if (params.companyId) {
        filterRules.push(f().eq('CompanyId', params.companyId));
    }

    if (params.onlyIncludeHealthChecks) {
        filterRules.push(f().ne('LastHealthCheck', null));
    }

    // Handle standard filter conditions
    let filterString = '';

    if (filterRules.length > 0) {
        // Get the combined filter string from ODataUtils but remove outer parentheses
        let combinedFilter = ODataUtils.andConditions(filterRules).toString();

        if (combinedFilter.startsWith('(') && combinedFilter.endsWith(')')) {
            combinedFilter = combinedFilter.substring(1, combinedFilter.length - 1);
        }

        filterString = combinedFilter;
    }

    if (params.lastHealthCheckDate) {
        const dateString = params.lastHealthCheckDate!.toISOString().split('T')[0];
        const dateFilter = `LastHealthCheck gt ${dateString}`;

        if (filterString) {
            filterString = `${filterString} and ${dateFilter}`;
        } else {
            filterString = dateFilter;
        }
    }

    return filterString || undefined;
};
